export const isQA = () => {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return apiUrl.includes('staging') || apiUrl.includes('api-qa');
};
